module.exports = __webpack_public_path__ + "static/media/haku.287f2125.jpg";